import React from 'react';

import Button from '@components/Button';
import { useAppContext } from '@contexts/AppContext';
import useServerSideRendering from '@hooks/useServerSideRendering';
import useWindowSize from '@hooks/useWindowSize';
import { getImgxSrc } from '@utils/images';

const HeaderSection = ({
  isSubscriber,
  subscribePromoUrl,
}: {
  isSubscriber: boolean;
  subscribePromoUrl: string;
}) => {
  const { width: windowWidth } = useWindowSize();
  const { env } = useAppContext();
  const hydrated = useServerSideRendering();

  return (
    <div className="mx-auto mt-20 flex justify-center border-0 border-b border-solid border-gray-300 sm:-mt-20 lg:justify-end">
      <div className="flex flex-wrap justify-between !px-16 sm:flex-col-reverse sm:!px-24 md:w-full lg:w-10/12 lg:flex-row lg:!px-0">
        <div className="pb-48 pr-24 sm:mt-24 sm:pb-64 md:w-full lg:mt-64 lg:w-7/12">
          <div className="font-serif text-headline-lg font-medium text-pro-red md:text-headline-xl ">
            Read The Information first…
            <span className="block text-black">
              {' '}
              or <em>them</em> later
            </span>
          </div>
          <div className="text-style body-lg mb-24 mt-8 font-serif font-normal text-[#545B69] lg:max-w-[520px]">
            The Information journalists get the news that other newsrooms envy. That’s why our
            exclusive deals, product launches and strategic moves were followed by the New York
            Times, Bloomberg, the Wall Street Journal and dozens of other outlets more than 400
            times in the last year.
          </div>
          <div className="font-serif text-headline-sm font-bold">
            Get the news straight from the source.
          </div>
          {!isSubscriber && (
            <Button
              className="text-sans mt-8 w-[240px] !text-body-lg !capitalize"
              rounded="slight"
              type="button"
              variant="primary"
              href={subscribePromoUrl}
            >
              Subscribe
            </Button>
          )}
        </div>
        {hydrated &&
          (windowWidth > 1200 ? (
            <div className="flex-shrink-0 lg:w-5/12">
              <img
                className="h-full w-full object-cover"
                src={getImgxSrc({
                  path: 'brand_campaign/heroDesktop.png',
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="Hero Image"
              />
            </div>
          ) : (
            <div className="w-full flex-shrink-0">
              <img
                className="hidden max-w-lg sm:flex sm:w-full sm:max-w-full"
                src={getImgxSrc({
                  path: 'brand_campaign/heroMidsize.png',
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="Hero Image"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default HeaderSection;
